<template>
    <div id="order">
        <div class="top_title fixed">购买商品</div>
        <goods-box2 :icon="icon" :title="title" :price="price" :num="num" :btStrengCount="btStrengCount" />
        <seamless-scroll :list1="baseEffect" :list2="NpProperty"
            v-if="baseEffect.length != 0 || NpProperty.length != 0" />

        <div class="order_box">
            <div class="role">
                <div class="prefix">
                    <div>收货角色</div>
                    <span class="role_info" v-if="role_id" @click="chooseRole">
                        {{ server_name }} {{role_name}} <i class="iconfont icon-change"></i>
                    </span>
                    <span class="role_info" v-else @click="chooseRole"><i class="iconfont icon-warning">i</i>请选择收货角色</span>
                </div>
            </div>
            <div class="pay_stepper">
                <div class="stepper">
                    <span class="prefix">购买数量</span>
                    <input type="number" :disabled="true" v-model="number" @blur="blur">
                </div>
                <div class="pay">
                    <span class="prefix">需支付</span>
                    <span class="money">&yen; {{(price*number).toFixed(3)}}</span>
                </div>
            </div>
            
        </div>
        <el-button class="pay_btn" type="primary" :loading="loading > 0" @click="confirm">购买</el-button>
        <div class="wallet" v-if="userData">我的钱包：&yen;{{ userData.balance }}</div>
        <div class="check">
            <van-popover v-model="showPopover" placement="top-start" get-container=".check">
                <div class="check_popover"> 购买前请先勾选</div>
            </van-popover>
            <el-checkbox v-model="agree">交易只可在同区角色间进行，单区有多个角色的请确认是否是您需要收货的角色，提交订单将直接完成购买。</el-checkbox>
        </div>

    </div>
</template>
<script>
    import $ from 'jquery'
    import crypto from "crypto";
    import Fingerprint2 from 'fingerprintjs2'
    export default {
        data() {
            return {
                icon: '',
                title: '',
                price: '', //单价
                num: 1, //最大数量
                number: 1, //购买数量
                loading: 0,
                agree: false,
                showPopover: false,
                baseEffect: [],
                NpProperty: [],
                min: 0, //最低价格
                max: 0, //最高价格
                btStrengCount: 0,
                role_id: '',
                role_name: '',
                roleList: [],
                account_id: '',
                psd: '', //密码
                pay_type: '',
                pay_amount: '',
                udid: '',
                order_num: '',
                app_id: '',
                prop_server_id: '',
                prop_server_name: '',
                server_id: '',
                server_name: '',
                uid: '',
                user_id: '',
                goods_id: '',
            }
        },
        computed: {
            params() {
                return {
                    // server_id: this.$store.state.home_server_id,
                    // server_name: this.$store.state.home_server_name,
                    role_id: this.role_id,
                    role_name: this.role_name,
                    goods_id: this.goods_id || this.$route.query.id,
                    account_id: this.account_id
                }
            },
            userData() {
                return this.$store.state.userData;
            },
            access_token() {
                return this.$store.state.access_token
            },
            isLogin() {
                return this.$store.getters.isLogin
            },
            isVerify() {
              return this.$store.getters.isVerify;
            },
        },
        created() {},
        mounted() {
            var quick_goods_id = this.$route.query.goods_id
            var quick_uid = this.$route.query.uid
            var quick_account_id = this.$route.query.account_id
            var quick_role_id = this.$route.query.role_id
            var quick_role_name = this.$route.query.role_name
            var quick_user_id = this.$route.query.user_id
            if(quick_goods_id&&quick_uid&&quick_account_id&&quick_role_id&&quick_role_name&&quick_user_id) {
                this.goods_id = quick_goods_id
                this.uid = quick_uid
                this.account_id = quick_account_id
                this.role_id = quick_role_id
                this.role_name = quick_role_name
                this.user_id = quick_user_id

                this.agree = true
                this.getGoodsDetail().then(() => {
                   this.confirm()
                })
            }else {
                this.getGoodsDetail()
            }
        },
        methods: {
            getUserRoleList() {
                if(!this.isVerify) {
                    this.$toast({
                        message: '请先验证身份',
                        duration: 2000,
                        onClose: () => {
                            this.$router.push({
                                name: "user.identity",
                                query: {
                                    redirect: this.$route.fullPath
                                }
                            });
                        },
                    })
                    return
                }
                var that = this
                this.$filterPop({
                    type: 'role2',
                    direction: 'up',
                    selection: {
                        app_id: this.app_id,
                        prop_server_id: this.prop_server_id
                    },
                    onSuccess: (data) => {
                        that.role_id = data.role_id
                        that.role_name = data.role_name
                        that.account_id = data.account_id
                        this.server_id = data.server_id
                        this.server_name = data.server_name
                    }
                })
            },
            chooseRole() {
                var that = this
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$store.dispatch("getUserData", true);
                            this.getUserRoleList()
                        }
                    })
                    return
                } else {
                    this.getUserRoleList()
                }
            },
            getGoodsDetail() {
                return this.$Ajax('goods/goods-detail', {
                    goods_id: this.params.goods_id
                }, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.app_id = rs.data.app_id
                        this.icon = rs.data.icon
                        this.price = rs.data.price
                        this.num = this.number = rs.data.num
                        this.prop_server_id = this.server_id = rs.data.server_id
                        this.prop_server_name = this.server_name = rs.data.server_name
                        if (rs.data.detailInfo) {
                            this.btStrengCount = rs.data.detailInfo.ItemDes.btStrengCount
                            this.title = rs.data.detailInfo.ItemName
                            if (rs.data.detailInfo.ItemDes.baseEffect) {
                                if(typeof rs.data.detailInfo.ItemDes.baseEffect == 'string') {
                                    this.baseEffect = JSON.parse(rs.data.detailInfo.ItemDes.baseEffect)
                                    return
                                }
                                this.baseEffect = rs.data.detailInfo.ItemDes.baseEffect
                            }
                            if (rs.data.detailInfo.ItemDes.NpProperty) {
                                if(typeof rs.data.detailInfo.ItemDes.NpProperty == 'string') {
                                    this.baseEffect = JSON.parse(rs.data.detailInfo.ItemDes.NpProperty)
                                    return
                                }
                                this.NpProperty = rs.data.detailInfo.ItemDes.NpProperty
                            }
                        }
                        // this.is_split = rs.data.is_split
                        // if(this.is_split == 0) {
                        //     this.number = this.num
                        // }
                    }
                })
            },
            confirm() {
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$store.dispatch("getUserData", true);
                        }
                    })
                    return
                } else {
                    this.$store.dispatch("getUserData", true);
                }
                if(!this.isVerify) {
                    this.$toast({
                        message: '请先验证身份',
                        duration: 2000,
                        onClose: () => {
                            this.$router.push({
                                name: "user.identity",
                                query: {
                                    redirect: this.$route.fullPath
                                }
                            });
                        },
                    })
                    return
                }

                if (this.role_id == '') {
                    this.$toast('请选择收货角色')
                    return
                }
                if (!this.agree) {
                    this.showPopover = true
                    this.loading = 0
                    return
                }
                
                this.loading++
                this.$Ajax('pay-password/isset', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        if (rs.data.isset) {
                            this.$Ajax('order-v2/order', {
                                app_id: this.app_id,
                                ...this.params,
                                server_id: this.server_id,
                                server_name: this.server_name,
                                num: this.number,
                            }).then(rs => {
                                if (rs.code == 200) {
                                    this.order_num = rs.data.order_num
                                    this.$filterPop({
                                        type: 'mixpay',
                                        direction: 'up',
                                        selection: {
                                            price: Number(this.price) * Number(this.number),
                                            balance: this.userData.balance
                                        },
                                        onSuccess: (e) => {
                                            this.pay_type = e.pay_type
                                            this.pay_amount = e.pay_amount
                                            if(e.pay_type == 2) {
                                                this.buy()
                                                return
                                            }
                                            this.$filterPop({
                                                type: 'password',
                                                direction: 'up',
                                                onFunc: (a) => {
                                                    this.psd = a.password
                                                    this.buy()
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        } else {
                            this.$RModal.tip({
                                selection: {
                                    title: '尚未设置支付密码，请先前往设置',
                                    btn: '前往设置'
                                },
                                onSuccess: () => {
                                    this.$router.push({
                                        name: 'user.password'
                                    })
                                }
                            })
                        }
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = 0
                    }, 2000)
                })
            },
            buy() {
                var that = this
                var params2 = {
                    order_num: this.order_num,
                    app_id: this.app_id,
                    account_id: this.params.account_id,
                    server_id: this.server_id,
                    server_name: this.server_name,
                    role_id: this.params.role_id,
                    role_name: this.params.role_name,
                    pay_type: this.pay_type,
                    pay_amount: this.pay_amount
                }
                if(this.psd) {
                    params2.password = this.psd
                }
                this.$Ajax('order-v2/pay', params2).then(rs => {
                    if (rs.code == 200) {
                        if(this.pay_type == 1) {
                            this.$router.push({
                                name: 'order.status',
                                query: {
                                    order_num: that.order_num,
                                    type: 'props'
                                }
                            })
                            return
                        }
                        window.location.href = `${this.$BaseURL}/order-v2/alipay?order_num=${rs.data.balance_order_num}`
                    }
                })
            },
            blur() {
                if (this.number < 1) {
                    this.number = 1
                }
            },

            async getUdid() {
                var that = this
                const fp = await new Promise((resolve) => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component, index) => {
                            if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不     一样
                                return component.value.replace(/\bNetType\/\w+\b/, '')
                            }
                            return component.value
                        })
                        // 生成最终id murmur 
                        // console.log(values,'使用的浏览器信息')  //使用的浏览器信息
                        const udid = Fingerprint2.x64hash128(values.join(''), 31)
                        // console.log(udid,'生成的标识码') //生成的标识码
                        that.udid = udid
                        resolve(udid);
                    })
                })
                return fp;
            },
            uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8,
                    1); // bits 6-7 of the      clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            },
            MD5(value) {
                return crypto.createHash("md5").update(value).digest("hex");
            },
            sign(params = {}) {
                const keys = Object.keys(params).sort();
                const signs = [];
                for (let key of keys) {
                    if (params[key] == null) continue;
                    signs.push(key + '=' + params[key]);
                }
                return this.MD5(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
            },
        },
        watch: {
            number: {
                immediate: true,
                handler(n) {
                    if (n < 1) {
                        // this.number = 1
                    } else if (n > Number(this.num)) {
                        this.number = this.num
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    #order {
        .order_box {
            background-color: #fff;
            padding: 1.3rem 1rem 2rem;
            border-radius: 1rem;
            margin-bottom: 1.2rem;

            .role {
                color: var(--theme);
                margin-bottom: 2.6rem;

                .prefix {
                    color: #000;
                    font-size: 1.6rem;
                    display: flex;
                    justify-content: space-between;
                    .role_info {
                        color: #F66F30;
                        font-size: 1.4rem;
                        font-weight: 700;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        .icon-warning {
                            width: 1.6rem;
                            height: 1.6rem;
                            line-height: 1.6rem;
                            border-radius: 50%;
                            border: 1px solid #F66F30;
                            color: #F66F30;
                            font-size: 1.2rem;
                            text-align: center;
                            transform: scale(0.8);
                            margin-right: 0.4rem;
                            font-weight: normal;
                        }
                        .icon-change {
                            margin-left: .8rem;
                            width: 1.8rem;
                            height: 1.8rem;
                            background: url(../../assets/bx/change.png) no-repeat center center;
                            background-size: 100% 100%;
                        }
                    }
                }
            }

            .pay_stepper {
                .pay {
                    word-break: break-all;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .prefix {
                        color: #000;
                        font-size: 1.6rem;
                    }
                    .money {
                        color: var(--red);
                        margin-left: 0.2rem;
                        font-size: 1.6rem;
                        font-weight: 700;
                    }
                }

                .stepper {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 2.6rem;
                    .prefix {
                        color: #000;
                        font-size: 1.6rem;
                    }
                    input {
                        width: 7rem;
                        height: 2.4rem;
                        padding: 0 0.6rem;
                        border-radius: 0.2rem;
                        text-align: end;
                        background-color: transparent;
                        border: none;
                        font-size: 1.6rem;
                        color: #000;
                    }
                }
            }
        }
    }
    .pay_btn {
        margin: 0 auto 1rem;
        display: block;
        padding: 0;
        width: 100%;
        height: 4rem;
        font-size: 1.4rem;
        border-radius: 10rem;
    }

    .wallet {
        text-align: center;
        color: #aaa;
    }
    .bottom_pop {
        height: 30rem;
        background-color: #f2f2f2;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;

        .close_btn {
            position: absolute;
            top: 1rem;
            right: 1rem;
            width: 1.8rem;
            height: 1.8rem;

            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 0.2rem;
                height: 2.4rem;
                background-color: var(--fade5);
            }

            &::before {
                transform: translate(-50%, -50%) rotate(45deg);
            }

            &::after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }

        .title {
            padding: 1rem 1.2rem;
            font-size: 1.6rem;
            margin-bottom: 2rem;
        }

        .pay_area {
            /deep/.el-form-item__content {
                height: 4rem;
                position: relative;
                padding: 0 !important;

                .pt {
                    position: absolute;
                    left: 1.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.4rem;
                }

                .error {
                    color: var(--red);
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 1.2rem;
                }

                .pay_type {
                    position: absolute;
                    right: 1.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.4rem;
                }
            }
        }

        .box {
            margin: 0 1rem;

            .el-form-item {
                margin-bottom: 0;
                border-bottom: 1px solid #eee;

                i {
                    color: var(--warning);
                }
            }

            /deep/.el-form-item__content {
                display: flex;
                align-items: center;
                background-color: #fff;
                border-radius: 0.3rem;
                padding-left: 1.2rem;
                font-size: 1.4rem;

                .label {
                    width: 5rem;
                    font-size: 1.3rem;
                }

                .el-input {
                    flex: 1;
                    border: none;
                    outline: none;

                    input {
                        border: none;
                        outline: none;
                        text-align: start;
                        padding: 0;
                        font-size: 1.3rem;
                    }
                }

                .el-form-item__error {
                    left: 1rem;
                    right: unset;
                    z-index: 10;
                    top: 100%;
                }
            }
        }
    }

    .pwd_area {
        /deep/.van-loading {
            i {
                color: #aaa !important;

            }
        }
    }

    .pwd_area2 {
        padding-top: 0;

        /deep/.el-form-item__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .ing {
            height: 2rem;
            font-size: 1rem;
            margin-top: -1rem;
        }
    }
</style>
